import { Modal } from "react-bootstrap";
import { GetTransactionGetMemberListOfDepositMoneyRepsonse } from "lib/worker/api/get_transaction_get_member_list_of_deposit_money";
import QRCode from "react-qr-code";

interface showPopUpModalProps {
  transactionDeposit: GetTransactionGetMemberListOfDepositMoneyRepsonse;
  show: boolean;
  handleClose?: Function | undefined;
}

export default function QrCodeDepositModal(props: showPopUpModalProps) {
  const { handleClose, show, transactionDeposit } = props;

  return (
    <Modal
      {...props}
      size="sm"
      scrollable={true}
      contentClassName="view-background-deposit-withdraw"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      animation={true}
      onHide={() => {
        if (handleClose) {
          handleClose();
        }
      }}
      dialogClassName="modal-popup"
    >
      <Modal.Body>
        <div
          style={{
            height: "auto",
            margin: "0 auto",
            maxWidth: 1024,
            width: "100%",
          }}
        >
          <div
            style={{
              border: "4px solid white",
              borderColor: "white",
              borderRadius: "2px",
            }}
          >
            <QRCode
              size={256}
              style={{
                height: "auto",
                maxWidth: "100%",
                width: "100%",
              }}
              value={transactionDeposit.TbvBankNum ?? ""}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>
        <div className="text-center">
          <label
            className="border-info"
            style={{ padding: "5px 5px 5px 5px", marginTop: 10 }}
          >
            <div style={{ fontSize: 12 }}>
              {"กรุณาสแกน QR Code เพื่อทำการโอนเงินของท่าน"}
            </div>
          </label>
        </div>
      </Modal.Body>
    </Modal>
  );
}
